import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  virmans: [],
};
const VirmanSlice = createSlice({
  name: "Virman",
  initialState: initialState,
  reducers: {
    showVirman: (state, action) => {
      state.virmans = action.payload;
    },
  },
});
export const { showVirman } = VirmanSlice.actions;
export default VirmanSlice.reducer;
